import { Search, X } from "lucide-react";
import { Input } from "./ui/input";

export const SearchInput = ({ value, onChange, placeholder, testId, className = "" }) => (
  <div className={`relative ${className}`}>
    <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testId}
      className="rounded-sm border-stone-300 pl-9 pr-9"
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange("")}
        data-testid={`${testId}-clear`}
        aria-label="Aramayı temizle"
        className="absolute right-2.5 top-1/2 -translate-y-1/2 flex h-5 w-5 items-center justify-center rounded-full text-stone-400 transition-colors duration-150 hover:bg-stone-200 hover:text-stone-700"
      >
        <X size={13} />
      </button>
    )}
  </div>
);
